<div class="health-check-error-dialog" role="alertdialog" aria-live="assertive">
  <p class="health-check-error-dialog__text">
    {{ 'common.healthCheckError' | translate }}
  </p>
  <button type="button" class="health-check-error-dialog__retry" (click)="reload()">
    {{ 'common.retry' | translate }}
  </button>
</div>
